import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { editPhotoActions, executeAIEraser } from '../../reducers/editPhoto';
import { Modal } from "flowbite-react";
import { AIProcessingPopup } from '../common/AIProcessingPopup';

const AIEraserConfirmPopup: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { showAIEraserConfirm, isAIEraserProcessing, aiEraserLines, aiEraserUsageByImage, currentImageId, aiEraserMaxUsage, stage } = useSelector((state: any) => state.editPhoto);
  const { beforeImageRef, afterImageRef } = useSelector((state: any) => state.roomDesign);

  // 残り使用回数を計算
  const aiEraserRemainingUsage = currentImageId
    ? aiEraserMaxUsage - (aiEraserUsageByImage[currentImageId] || 0)
    : aiEraserMaxUsage;

  const handleExecute = () => {
    if (stage && beforeImageRef && afterImageRef && aiEraserLines.length > 0) {
      dispatch(executeAIEraser({
        stage,
        beforeImageRef,
        afterImageRef,
        aiEraserLines,
        currentImageId: currentImageId || ''
      }))
    }
  };

  const handleCancel = () => {
    // キャンセル処理
    dispatch(editPhotoActions.setShowAIEraserConfirm(false));
  };

  // 処理中ポップアップを表示
  if (isAIEraserProcessing) {
    return (
      <AIProcessingPopup
        show={true}
        title="AI消しゴムを実行中..."
        description="AIが選択した領域を解析して消去・補完しています。"
        subDescription="しばらくお待ちください..."
      />
    );
  }

  // 確認ポップアップも表示しない場合はnullを返す
  if (!showAIEraserConfirm) return null;

  const popupContent = (
    // 確認ポップアップ
    <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 99999 }}>
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={handleCancel} style={{ zIndex: 99999 }}></div>
      <div className="relative bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4" style={{ zIndex: 100000 }}>
        <h3 className="text-lg font-semibold mb-4">AI消しゴムを実行しますか？</h3>

        <div className="mb-4">
          <p className="text-sm text-gray-600">
            描画された{aiEraserLines.length}箇所のAI消しゴム領域をAIで自動的に消去・補完します。
          </p>
          <p className="text-sm text-orange-600 mt-2">
            残り使用回数: {aiEraserRemainingUsage}/{aiEraserMaxUsage}回
          </p>
          <p className="text-sm text-gray-500 mt-1">
            ※実行後は使用回数が1回消費されます
          </p>
        </div>

        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={handleCancel}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={handleExecute}
            className="px-4 py-2 text-white bg-orange-500 rounded-lg hover:bg-orange-600 transition-colors"
            disabled={aiEraserRemainingUsage <= 0}
          >
            実行
          </button>
        </div>
      </div>
    </div>
  );

  // React Portalを使用してbodyの直下にレンダリング
  return ReactDOM.createPortal(popupContent, document.body);
};

export default AIEraserConfirmPopup;